import SvgIcon from '@mui/material/SvgIcon';
import * as React from 'react';
const SvgCircleInfo = (props)=>/*#__PURE__*/ React.createElement(SvgIcon, {
        ...props,
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M12 3a9 9 0 0 0-9 9 9 9 0 0 0 9 9 9 9 0 0 0 9-9 9 9 0 0 0-9-9m0 16.313c-4.032 0-7.312-3.28-7.312-7.313S7.967 4.688 12 4.688s7.313 3.28 7.313 7.312-3.28 7.313-7.313 7.313m1.406-4.5h-.562v-3.094a.844.844 0 0 0-.844-.844h-1.125a.846.846 0 0 0-.844.844c0 .464.38.844.844.844h.281v2.25h-.562a.846.846 0 0 0-.844.843c0 .464.38.844.844.844h2.812a.844.844 0 0 0 0-1.687M12 9.75a1.125 1.125 0 1 0 0-2.25 1.125 1.125 0 0 0 0 2.25"
    }));
export default SvgCircleInfo;
